import React from 'react';

import RheIcon from '@RHEnvironmental/pattern-library/dist/js/components/RheIcon';
import PageHeading from '@RHEnvironmental/pattern-library/dist/js/components/PageHeading';
import BodyText from '../BodyText';

import dateFormat from '../../../services/ui/date';

const DocumentPdfCard = ({ pdf, onDeleteClick, onDownloadClick, canEdit = true }) => (
    <div className="p-1 mb-1 document-pdf-card">
        <div className="mr-1 icon-box">
            <RheIcon
                className="document-icon"
                title="pdf"
                icon="library"
                backgroundColor="#005a5a"
            />
        </div>
        <div className="mr-1 text-box">
            <PageHeading level={4}>Label</PageHeading>
            <BodyText className="mb-2">{pdf._formatted.display_name}</BodyText>
            <PageHeading level={4}>Filename</PageHeading>
            <BodyText className="mb-2">{pdf.name}</BodyText>
            <PageHeading level={4}>Upload date</PageHeading>
            <BodyText className="mb-2">
                {dateFormat.standard(pdf.created_at)}
            </BodyText>
        </div>
        <div className="action-box">
            {onDownloadClick && (
                <RheIcon
                    className="document-icon"
                    title="Download pdf"
                    altText={`Download pdf `}
                    tabIndex="0"
                    icon="linear download"
                    foregroundColor="#005a5a"
                    onClick={() => {
                        onDownloadClick(document.id);
                    }}
                />
            )}

            {onDeleteClick && canEdit && (
                <RheIcon
                    className="document-icon"
                    title={`Delete defect pdf `}
                    altText={`Delete defect pdf `}
                    tabIndex="0"
                    icon="linear wastebasket"
                    foregroundColor="#ff0000"
                    onClick={() => {
                        onDeleteClick(document.id);
                    }}
                />
            )}
        </div>
    </div>
);

export default DocumentPdfCard;
